import axios from '@axios'

const PREFIX = '/envio-automatico'

export default {
  getConfigs() {
    return axios.get(`${PREFIX}`)
  },

  salvarConfig(config) {
    return axios.post(`${PREFIX}`, config)
  },

  salvarEmpresas(tipoRotina, empresasIds) {
    return axios.put(`${PREFIX}/${tipoRotina}/empresas`, empresasIds)
  },

  getLogs(tipoRotina) {
    return axios.get(`${PREFIX}/log/${tipoRotina}`)
  },

  getHistoricoEnvios(tipoRotina) {
    return axios.get(`${PREFIX}/historico-envios/${tipoRotina}`)
  },

  getEmpresasParaVinculo(tipoRotina) {
    return axios.get('/usuarios/empresas', { params: { tipoRotina } })
  },
}
